import React from "react"
import Icon from "@ant-design/icons"

const unlinkIconSvg = (props: { bgColor?: string; color?: string }) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        {props.bgColor && <rect width="32" height="32" rx="5" fill={props.bgColor} />}
        <g transform="translate(7, 7)" clipPath="url(#clip0_1782_11903)">
            <path
                d="M8.07797 11.9032C8.01441 12.2159 7.88509 12.5114 7.69859 12.7703C7.5121 13.0291 7.27268 13.2453 6.99624 13.4046L5.04768 14.5296C4.53089 14.828 3.91674 14.9088 3.34034 14.7544C2.76393 14.5999 2.27249 14.2228 1.97412 13.706L1.41162 12.7318C1.11325 12.215 1.0324 11.6008 1.18685 11.0244C1.34129 10.448 1.71839 9.95657 2.23518 9.6582L4.18374 8.5332C4.52531 8.3376 4.91222 8.23503 5.30583 8.23572C5.69944 8.23642 6.08599 8.34036 6.42687 8.53717M9.88555 6.54029C9.88555 6.14668 9.98881 5.75995 10.185 5.41873C10.3812 5.0775 10.6635 4.79371 11.0037 4.5957L12.9522 3.4707C13.469 3.17233 14.0832 3.09148 14.6596 3.24593C15.236 3.40037 15.7274 3.77747 16.0258 4.29426L16.5883 5.26854C16.8867 5.78533 16.9675 6.39948 16.8131 6.97588C16.6586 7.55229 16.2815 8.04373 15.7647 8.3421L13.8162 9.4671C13.54 9.62687 13.2331 9.7261 12.9157 9.75819C12.5982 9.79027 12.2776 9.75449 11.9751 9.65321"
                stroke={props.color || "white"}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.69847 6.61253L1.24072 5.68603M9.08273 4.08128L10.0092 0.623527M6.74998 5.10333L4.78123 1.69336M8.91722 13.9196L7.99072 17.3774M13.3015 11.3884L16.7592 12.3149M11.25 12.8976L13.2187 16.3075"
                stroke={props.color || "white"}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_1782_11903">
                <rect width="18" height="18" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

interface UnlinkIconProps extends Omit<React.ComponentProps<typeof Icon>, "component"> {
    bgColor?: string
    color?: string
}

export const UnlinkIcon = ({ bgColor, color, ...props }: UnlinkIconProps) => <Icon component={() => unlinkIconSvg({ color, bgColor })} {...props} />
